// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "-legacy." + {"131":"7dbf9334","194":"c18a8eac","260":"7cff7203","440":"e1f5ddee","509":"5cd95f90","581":"50ce78ae","668":"07776187","762":"fd3fe5f3","811":"e55108d4","902":"56a0ac24","973":"cb36d46a","983":"8e5c894d"}[chunkId] + ".js";
};